import * as React from "react";
import * as classNames from "classnames";
import { withTheme } from "../../common/withTheme";
import MediaQuery from 'react-responsive';

interface ICollapseProps {
    buttonClassName?: string;
    children?: any;
    theme?: string;
    className?: string;
    title?: string;
}

interface ICollapseState {
    show: boolean;
}

class Collapse extends React.Component<ICollapseProps, ICollapseState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            show: false
        }

        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow() {
        this.setState({ show: !this.state.show });
    }

    componentDidMount() {
    }

    render() {
        return <>
            <MediaQuery maxWidth={767}>
                <button className={classNames(this.props.buttonClassName, "btn btn-light px-3 py-2")} onClick={this.toggleShow}>
                    {this.props.title}
                </button>

                <div className="position-absolute w-50 collapse-child">{React.cloneElement(this.props.children, {show: this.state.show})}</div>

            </MediaQuery>
            <MediaQuery minWidth={768}>
                {React.cloneElement(this.props.children, {show: true})}
            </MediaQuery>
        </>;
    };
}

export default withTheme<ICollapseProps>(Collapse);